var _effectorFileName = "/src/page-content/home/components/our-offers/our-offers.tsx";
import { Article } from '@/shared/components/article';
import { Table, TableBody, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/shared/components/ui/table';
import { OUR_OFFERS } from './constants/company-offers';
export const OurOffers = () => {
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">What We Offer</h2>

      <Table className="sm:min-w-auto w-full min-w-[480px]">
        <TableHeader>
          <TableRow>
            <TableHead className="min-w-40">Class Type</TableHead>
            <TableHead className="min-w-36">Lesson Duration</TableHead>
            <TableHead className="min-w-32">Group Size</TableHead>
            <TableHead className="min-w-24 text-right">Price</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {OUR_OFFERS.map((offer, index) => <TableRow key={index} className="text-sm sm:text-base">
              <TableCell className="max-w-20 overflow-hidden text-ellipsis whitespace-nowrap font-medium">
                {offer.type}
              </TableCell>

              <TableCell>{offer.duration}</TableCell>
              <TableCell className="max-w-xs">{offer.studentsNumber}</TableCell>
              <TableCell className="text-right font-semibold">{offer.price} &#8364;</TableCell>
            </TableRow>)}
        </TableBody>

        <TableFooter>
          <TableRow>
            <TableCell colSpan={1}>Promo code for company employees:</TableCell>
            <TableCell colSpan={3}>10% off all lessons (individual students only).</TableCell>
          </TableRow>
        </TableFooter>
      </Table>

      <p className="mt-2 text-right text-xs text-muted-foreground">
        <sup>*</sup>All prices incl. 0 % VAT
      </p>
      <p className="mt-1 text-right text-xs text-muted-foreground">
        <sup>**</sup>Prices are for informational purposes only
      </p>
    </Article>;
};